<div class="flex flex-col bg-white rounded-[14px] p-[30px] w-full gap-[20px]">
  <!-- Navigation entre les mois -->
  <div class="flex items-center justify-between gap-[15px]">
    <button type="button" (click)="previousMonth()" [attr.aria-label]="'date_picker.previous_month' | translate"
      class="size-[64px] shrink-0 flex items-center justify-center border border-gris-3 rounded-[10px] bg-white cursor-pointer hover:bg-gris-4 transition-colors">
      <span class="material-icons fg-noir-2 text-[32px]">chevron_left</span>
    </button>

    <span class="text-[20px] font-semibold fg-noir-2 text-center">{{ monthLabel() | capitalize }}</span>

    <button type="button" (click)="nextMonth()" [attr.aria-label]="'date_picker.next_month' | translate"
      class="size-[64px] shrink-0 flex items-center justify-center border border-gris-3 rounded-[10px] bg-white cursor-pointer hover:bg-gris-4 transition-colors">
      <span class="material-icons fg-noir-2 text-[32px]">chevron_right</span>
    </button>
  </div>

  <!-- Grille du mois -->
  <div class="grid grid-cols-7 gap-[6px]">
    @for (weekday of weekdayLabels(); track $index) {
    <span class="h-[40px] flex items-center justify-center text-[14px] font-semibold fg-gris-1 uppercase">
      {{ weekday }}
    </span>
    }

    @for (cell of cells(); track cell.iso) {
    <button type="button" (click)="dateSelect.emit(cell.iso)"
      class="h-[64px] flex items-center justify-center rounded-[10px] text-[19px] font-medium cursor-pointer transition-colors border"
      [class.bg-vert-1]="cell.isSelected" [class.text-white]="cell.isSelected"
      [class.fg-noir-2]="cell.inMonth && !cell.isSelected"
      [class.fg-gris-2]="!cell.inMonth && !cell.isSelected" [class.border-vert-1]="cell.isToday"
      [class.border-transparent]="!cell.isToday">
      {{ cell.day }}
    </button>
    }
  </div>

  <!-- Actions -->
  <div class="flex gap-[10px]">
    <button type="button" (click)="clearClick.emit()"
      class="border border-gris-3 rounded-[5px] h-[58px] px-5 flex-1 flex items-center justify-center fg-noir-2 text-[16px] font-medium cursor-pointer hover:bg-gris-4 transition-colors">
      {{ 'date_picker.clear' | translate }}
    </button>
    <button type="button" (click)="selectToday()"
      class="border border-gris-3 rounded-[5px] h-[58px] px-5 flex-1 flex items-center justify-center fg-noir-2 text-[16px] font-medium cursor-pointer hover:bg-gris-4 transition-colors">
      {{ 'date_picker.today' | translate }}
    </button>
    <button type="button" (click)="cancelClick.emit()"
      class="h-[58px] flex-1 px-[20px] flex items-center justify-center bg-vert-1 rounded-[5px] text-[16px] font-semibold text-white cursor-pointer hover:brightness-95 transition-all">
      {{ 'common.cancel' | translate }}
    </button>
  </div>
</div>
